module.exports = __webpack_public_path__ + "img/trash.f5d391ff.svg";